import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { useContext } from 'react';
import { BreakpointsContext, BreakpointsProvider } from './BreakpointsProvider';
function useBreakpoints(breakpointsToWatch) {
  var breakpoints = useContext(BreakpointsContext);
  var watchedBreakpoints = typeof breakpointsToWatch === 'string' ? [breakpointsToWatch] : breakpointsToWatch;
  var currentBreakpoint;
  if (watchedBreakpoints !== null && watchedBreakpoints !== void 0 && watchedBreakpoints.length) {
    currentBreakpoint = 'base';
    watchedBreakpoints.forEach(function (bp) {
      if (breakpoints[bp]) {
        currentBreakpoint = bp;
      }
    });
  }
  return _objectSpread(_objectSpread({}, breakpoints), {}, {
    currentBreakpoint: currentBreakpoint
  });
}
export { BreakpointsContext, BreakpointsProvider };
export default useBreakpoints;